module.exports = __webpack_public_path__ + "img/missing.3ffa6c5f.png";